var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 0.333984C3.31778 0.333984 0.333008 3.31875 0.333008 7.00065C0.333008 10.6825 3.31778 13.6673 6.99967 13.6673C10.6816 13.6673 13.6663 10.6825 13.6663 7.00065C13.6663 3.31875 10.6816 0.333984 6.99967 0.333984ZM1.30862 7.00065C1.30862 3.85757 3.85659 1.30959 6.99967 1.30959C10.1428 1.30959 12.6907 3.85757 12.6907 7.00065C12.6907 10.1437 10.1428 12.6917 6.99967 12.6917C3.85659 12.6917 1.30862 10.1437 1.30862 7.00065ZM6.49967 10.334V6.00065C6.49967 5.72451 6.72353 5.50065 6.99967 5.50065C7.27582 5.50065 7.49967 5.72451 7.49967 6.00065V10.334C7.49967 10.6101 7.27582 10.834 6.99967 10.834C6.72353 10.834 6.49967 10.6101 6.49967 10.334ZM7.49967 3.66732C7.49967 3.39118 7.27582 3.16732 6.99967 3.16732C6.72353 3.16732 6.49967 3.39118 6.49967 3.66732V4.00065C6.49967 4.27679 6.72353 4.50065 6.99967 4.50065C7.27582 4.50065 7.49967 4.27679 7.49967 4.00065V3.66732Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.856fecf94ae90a464a930646bad221fe.svg";
export { ForwardRef as ReactComponent };